import {
  adminChipActiveClass,
  adminChipInactiveClass,
} from "@/components/common/surfaceClasses";

/** Shared mode-tab / filter-chip class builder for Admin Contacts directory. */
export function adminContactsModeTabClass(active: boolean, extraInactive = ""): string {
  const base = "px-3 py-1.5 rounded-lg border text-sm ";
  if (active) return base + adminChipActiveClass;
  return base + adminChipInactiveClass + (extraInactive ? ` ${extraInactive}` : "");
}

export function adminContactsFilterChipClass(active: boolean): string {
  const base = "px-2.5 py-1 rounded-lg border text-xs ";
  if (active) return base + adminChipActiveClass;
  return base + adminChipInactiveClass;
}

export function adminContactsSmallFilterChipClass(active: boolean): string {
  const base = "px-2 py-1 rounded border text-xs ";
  if (active) return base + adminChipActiveClass;
  return base + adminChipInactiveClass;
}
